module.exports = __webpack_public_path__ + "static/media/zhengs2-2.35d45c9b.png";